const NON_UNION_SCHEDULES = ['A', 'OT', 'CR', 'FS', 'PO', 'XT', 'M'];

export default workScheduleCode =>
  NON_UNION_SCHEDULES.includes(workScheduleCode);
